/**
 * The bits of Beancount's syntax that every converter needs to agree on.
 *
 * Both the CSV and the Ledger converter emit Beancount, so account validity,
 * string quoting and the fallback commodity have to mean the same thing in
 * each. They were duplicated once and had already drifted (one rebuilt the
 * account regex on every call); keep the single definition here.
 */

const ACCOUNT_RE =
  /^(Assets|Liabilities|Equity|Income|Expenses)(:[\p{Lu}\p{N}][\p{L}\p{N}-]*)+$/u;

/** True when `name` is a syntactically valid Beancount account. */
export function isValidAccount(name: string): boolean {
  return ACCOUNT_RE.test(name.trim());
}

const COMMODITY_RE = /^[A-Z][A-Z0-9._-]*$/;

/** True when `code` is a syntactically valid Beancount commodity. */
export function isValidCommodity(code: string): boolean {
  return COMMODITY_RE.test(code.trim());
}

/** Beancount string literal: quotes and backslashes escaped. */
export function quote(text: string): string {
  return `"${text.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}

/** Commodity assumed when the source gives only a bare number. */
export const DEFAULT_CURRENCY = "USD";
